'use strict'
const accordion = [].slice.call( document.querySelectorAll( '[data-accordion]' ) );

if( accordion ) {
  accordion.forEach( (element) => {
    let accordionItem = [].slice.call( element.querySelectorAll( '[data-accordion-item]' ) )
    accordionItem.forEach( (accordionElement) => {
      accordionElement.querySelector( '.accordion-title' ).addEventListener( 'click', function( event ) {
        let accordionParent = accordionElement.parentNode.querySelector( '.accordion-item--active' )
        if( accordionParent ) {
          accordionParent.classList.remove( 'accordion-item--active' )
        }
        this.parentNode.classList.add( 'accordion-item--active' )
      } )
    } )
  } )
}
